'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EditableNavigationItem = require('../containers/EditableNavigationItem');

var _EditableNavigationItem2 = _interopRequireDefault(_EditableNavigationItem);

var _propTypes3 = require('../propTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NavigationItemList(_ref) {
  var baseUrl = _ref.baseUrl,
      navigationItems = _ref.navigationItems,
      _ref$navigationSectio = _ref.navigationSectionId,
      navigationSectionId = _ref$navigationSectio === undefined ? null : _ref$navigationSectio;

  var itemsInList = void 0;
  if (navigationSectionId) {
    itemsInList = navigationItems.getNavigationItemsInSection(navigationSectionId);
  } else {
    itemsInList = navigationItems.getRoots();
  }

  var renderedItems = itemsInList.map(function (navigationItem) {
    return _react2.default.createElement(_EditableNavigationItem2.default, {
      key: navigationItem.id,
      navigationItem: navigationItem,
      baseUrl: baseUrl
    });
  });

  return _react2.default.createElement(
    'ul',
    { className: 'list-group navigation-item-list' },
    renderedItems
  );
}

NavigationItemList.propTypes = {
  baseUrl: _propTypes2.default.string.isRequired,
  navigationItems: _propTypes3.NavigationItemStorePropType.isRequired,
  navigationSectionId: _propTypes2.default.number
};

NavigationItemList.defaultProps = {
  navigationSectionId: null
};

exports.default = NavigationItemList;


//////////////////
// WEBPACK FOOTER
// ./~/cadmus-navbar-admin/lib/components/NavigationItemList.js
// module id = 206
// module chunks = 0